contentHandler = {
    $dataContainer: $('.data-container'),

    blockPeopleImages: function (){
        var $objImgCont = $('.panel-people-container').find('.image-container');
        var width = $objImgCont.outerWidth();
        $objImgCont.outerHeight( width ); 
    },

    initAccessibility: function() {
        // replace content's h2 to h3 with h2-style
        $('.def-content-container h2').not('.content-index-title, .h1-style, .small-headings h2, .hide').each(function() {
            var $current = $(this);
            var classNames = $current.attr('class');
            $('<h3 class="h2-style '+(classNames ? classNames : '')+'">'+$current.html()+'</h3>').insertAfter($current);
            $current.remove();
        });
        // replace content's h1 to h2 with h1-style
        $('.def-content-container h1').each(function() {
            var $current = $(this);
            var classNames = $current.attr('class');
            $('<h2 class="h1-style '+(classNames ? classNames : '')+'">'+$current.html()+'</h2>').insertAfter($current);
            $current.remove();    
        });
        // wrap gravity forms with aria-live so thank you message can be reached by screen reader
        // $('.gform_wrapper').each(function() {
        //     $(this).wrap('<div aria-live="polite"></div>');
        // });
        // focus on form anchor after successfull submission so tabbing continues to next element
        // $(document).on('gform_confirmation_loaded', function(event, formId) {
        //     console.log($('.gform_anchor#gf_'+formId));
        //     $('.gform_anchor#gf_'+formId).focus();
        // });
    },
  
    init: function() {
        var self = this;
        this.blockPeopleImages();
        self.$dataContainer.each(function() {
            var screenHeight = window.screen.height - $('header').outerHeight();
            $('.image-on-left, .image-on-right').each(function() {
                $image = $(this).find('.image-thumbnail');
                var imageHeight = $($image).height();
                var imageWidth = $($image).width();

                $image.css('opacity', '1');

                if (imageHeight > screenHeight) {
                    var newHeight = (screenHeight * 17) / 20;
                    var newWidth  = (newHeight / imageHeight) * imageWidth;

                    $image.css({
                        'max-height' : newHeight,
                        'max-width' : newWidth,
                        'opacity' : '1'
                    });
                }
            });
        });

        var screenHeight    = window.screen.height / 2;
    
        $(window).scroll(function(){
            self.$dataContainer.each(function() {
                var containerHeight = $(this).height();
                var scrollStart     = $(this).offset().top + 100;
                var scrollEnd       = ($(this).offset().top + containerHeight); 
                var top             = $(document).scrollTop() + screenHeight;

                $sideText           = $(this).find('.side-text-container');

                if ((top >= scrollStart && top <= scrollEnd)) {
                    $sideText.addClass('show-text');
                } else {
                    $sideText.removeClass('show-text');
                }
            });
        });

        $('p:empty').remove();
        if (Foundation.MediaQuery.only('small')) {
            $('.wp-block-column:empty').remove();
        }

        // all wp-block-columns receive grid-x grid-margin-x, and all its wp-block-column children receive cell
        // set medium-xx on the column's custom css class to set width
        $('.wp-block-columns').addClass('grid-x grid-margin-x');
        $('.wp-block-column').addClass('cell');

        //h5 on all wp column should be larger
        $('.wp-block-column h5').addClass('large');

        this.initAccessibility();

    }
}